import * as React from 'react';
import './style.css';
import { Advert as AdvertModel } from '../../models/Advert';
import { MediaIf } from '../Utils/Responsive';
import * as ReactGA from 'react-ga';

export interface AdvertProps {
  className?: string;
  adverts?: Array<AdvertModel>;
}

export interface AdvertState {
  /* empty*/
}

export class Advert extends React.Component<AdvertProps, AdvertState> {
  getAdvertImage(advert: AdvertModel) {
    return advert.mediaQuery ? (
      <MediaIf
        className="edge-of-play-advert-image"
        query={advert.mediaQuery}
        tag="img"
        src={advert.imageUrl}
        alt={advert.altText}
      />
    ) : (
      <img key={advert.imageUrl} src={advert.imageUrl} alt={advert.altText} />
    );
  }

  render() {
    const { adverts, className = '' } = this.props;

    if (!adverts || !adverts.length) {
      return null;
    }

    return (
      <div className={'edge-of-play-advert ' + className}>
        {adverts.map(advert => (
          <ReactGA.OutboundLink
            eventLabel={this.getAnalyticsLabel(advert)}
            to={advert.href}
            key={`${advert.imageUrl}-${advert.id}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {this.getAdvertImage(advert)}
          </ReactGA.OutboundLink>
        ))}
      </div>
    );
  }

  private getAnalyticsLabel = (advert: AdvertModel): string => {
    return [this.sanitizeHref(advert.href), advert.imageUrl, advert.slot].join(
      '|'
    );
  };

  private sanitizeHref = (href: string): string => {
    // ReactGA redacts the eventlabel
    // if email present in EL and checks for '@'
    // hence why removing it.
    return href.replace(/@/g, '<at>');
  };
}

export default Advert;



// WEBPACK FOOTER //
// ./src/app/components/Advert/index.tsx